document.addEventListener("click", (e) => {
  const openBtn = e.target.closest("[data-fruit-lightbox-open]");
  const lightbox = document.querySelector(".fruit-lightbox");
  const content = document.querySelector(".fruit-lightbox__content");

  if (!lightbox || !content) return;

  if (openBtn) {
    const template = openBtn.querySelector("template");
    if (!template) return;

    content.innerHTML = "";
    content.appendChild(template.content.cloneNode(true));

    lightbox.hidden = false;
    document.body.style.overflow = "hidden";
    return;
  }

  const clickedClose = e.target.closest(".fruit-lightbox__close");
  const clickedBackdrop =
    e.target.classList && e.target.classList.contains("fruit-lightbox");

  if (clickedClose || clickedBackdrop) {
    lightbox.hidden = true;

    const video = content.querySelector("video");
    if (video) video.pause();

    content.innerHTML = "";
    document.body.style.overflow = "";
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const kitInputs = document.querySelectorAll(".fruit-product__kit-input");
  const formVariantInput = document.querySelector(
    '#fruit-product-form input[name="id"]'
  );

  if (!kitInputs.length || !formVariantInput) return;

  /* 1️⃣ sincroniza variante inicial (editor / Liquid) */
  const checkedKit = document.querySelector(
    ".fruit-product__kit-input:checked"
  );

  if (checkedKit) {
    formVariantInput.value = checkedKit.value;
  }

  /* 2️⃣ atualiza quando o usuário troca */
  kitInputs.forEach((input) => {
    input.addEventListener("change", () => {
      if (!input.checked) return;
      formVariantInput.value = input.value;
    });
  });
});

document.addEventListener('click', (e) => {
  const thumb = e.target.closest('.fruit-product__thumb');
  if (!thumb) return;

  const index = Number(thumb.dataset.index);

  // troca imagem principal
  document
    .querySelectorAll('.fruit-product__image-item')
    .forEach((item, i) => {
      item.classList.toggle('is-active', i === index);
    });

  // estado ativo da thumb
  document
    .querySelectorAll('.fruit-product__thumb')
    .forEach((t, i) => {
      t.classList.toggle('is-active', i === index);
    });
});

(() => {
  let startX = 0;
  let startY = 0;
  let isDragging = false;

  const THRESHOLD = 10; // px — tolerância do dedo

  document.addEventListener('touchstart', (e) => {
    const target = e.target.closest('.fruit-product__image-click');
    if (!target) return;

    const touch = e.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    isDragging = false;
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    const touch = e.touches[0];
    if (!touch) return;

    const diffX = Math.abs(touch.clientX - startX);
    const diffY = Math.abs(touch.clientY - startY);

    if (diffX > THRESHOLD || diffY > THRESHOLD) {
      isDragging = true;
    }
  }, { passive: true });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.fruit-product__image-click');
    if (!btn) return;

    if (isDragging) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
  }, true);
})();

document.addEventListener("DOMContentLoaded", () => {
  const qtyWrapper = document.querySelector("[data-fruit-qty]");
  const productForm = document.querySelector("#fruit-product-form");

  if (!qtyWrapper || !productForm) return;

  const minusBtn = qtyWrapper.querySelector("[data-fruit-qty-minus]");
  const plusBtn  = qtyWrapper.querySelector("[data-fruit-qty-plus]");
  const inputUI  = qtyWrapper.querySelector(".fruit-product__qty-input");
  const inputForm = productForm.querySelector('input[name="quantity"]');

  if (!minusBtn || !plusBtn || !inputUI || !inputForm) return;

  const sync = (value) => {
    const qty = Math.max(1, Number(value) || 1);
    inputUI.value = qty;
    inputForm.value = qty;
  };

  minusBtn.addEventListener("click", () => {
    sync(Number(inputUI.value) - 1);
  });

  plusBtn.addEventListener("click", () => {
    sync(Number(inputUI.value) + 1);
  });

  inputUI.addEventListener("change", () => {
    sync(inputUI.value);
  });

  // garante sincronização inicial
  sync(inputUI.value);
});
